import cx from 'classnames';
import React from 'react';
import LazyLoad from 'react-lazyload';

import * as styles from './styles.less';

interface Props {
    className?: string;
    imageURL: string;
    title: string;
    url: string;
}

const ShowPoster: React.SFC<Props> = props => (
    <a
        className={ cx(styles.root, props.className) }
        href={ props.url }
    >
        <LazyLoad
            once
            placeholder={
                <img
                    className={ styles.placeholder }
                    data-src={ props.imageURL }
                />
            }
        >
            <img
                className={ styles.image }
                src={ props.imageURL }
                title={ props.title }
            />
        </LazyLoad>
        <h3 className={ styles.title }>{ props.title }</h3>
        { /* <span className={ styles.titleWrapper }> */ }
        { /* </span> */ }
    </a>
);

export default ShowPoster;
